import { useRouter } from 'next/router'
import { useArcade } from '@/features/arcade/provider'

type ArcadeRoute = {
  path: string
  active: boolean
  goTo: () => Promise<boolean>
}

export const OVERVIEW_PAGE_SECTION_ID = {
  HOW_TO_PLAY: 'how-to-play',
  POINT_VALUES: 'point-values',
  TIMELINE: 'timeline',
  CONVERT: 'convert'
}

export const HOW_TO_PLAY_PATH =
  `/arcade/#${OVERVIEW_PAGE_SECTION_ID.HOW_TO_PLAY}` as const
export const OVERVIEW_PATH = `/arcade/` as const
export const OVERVIEW_CONVERT_PATH =
  `/arcade/#${OVERVIEW_PAGE_SECTION_ID.CONVERT}` as const
export const OVERVIEW_TIMELINE_PATH =
  `/arcade/#${OVERVIEW_PAGE_SECTION_ID.TIMELINE}` as const
export const OVERVIEW_POINT_VALUES_PATH =
  `/arcade/#${OVERVIEW_PAGE_SECTION_ID.POINT_VALUES}` as const
export const PRIZE_WALL_PATH = `/arcade/prize-wall` as const
export const LEADERBOARD_PATH = '/arcade/leaderboard' as const
export const SHOP_PATH = '/arcade/shop' as const
export const CONVERT_PTS_PATH =
  '/inventory/?exclude_non_arcade=true&selectionMode=convert' as const

export const useArcadeRouting = () => {
  const router = useRouter()
  const { player } = useArcade()

  const howToPlay: ArcadeRoute = {
    path: HOW_TO_PLAY_PATH,
    active: router.asPath.startsWith(HOW_TO_PLAY_PATH),
    goTo: async () => await router.push(HOW_TO_PLAY_PATH)
  }

  const overview: ArcadeRoute = {
    path: OVERVIEW_PATH,
    active: router.asPath.startsWith(OVERVIEW_PATH),
    goTo: async () => await router.push(OVERVIEW_PATH)
  }

  const prizeWall: ArcadeRoute = {
    path: PRIZE_WALL_PATH,
    active: router.asPath.startsWith(PRIZE_WALL_PATH),
    goTo: async () => await router.push(PRIZE_WALL_PATH)
  }

  const playerAccount = !!player ? `/?account=${player.account}` : ''
  const leaderboardPath = `${LEADERBOARD_PATH}${playerAccount}`

  const leaderboard: ArcadeRoute = {
    path: leaderboardPath,
    active: router.asPath.startsWith(leaderboardPath),
    goTo: async () => await router.push(leaderboardPath)
  }

  const convertPoints: ArcadeRoute = {
    path: `${CONVERT_PTS_PATH}`,
    active: router.asPath.startsWith(CONVERT_PTS_PATH),
    goTo: async () => await router.push(CONVERT_PTS_PATH)
  }

  return {
    overview,
    howToPlay,
    prizeWall,
    leaderboard,
    convertPoints
  }
}
